import React, { useState, useEffect } from "react";
import API_DOMAIN from "../config/config";
import {
  Container,
  Nav,
  Navbar,
  Col,
  Row,
  Offcanvas,
  Modal,
  ModalBody,
  Form,
} from "react-bootstrap";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { Buttons } from "../components/Buttons";
import { PDFDownloadLink, pdf } from "@react-pdf/renderer";
import { TableUI } from "../components/Tables";
import { PageHead, PageTitle } from "../components/PageTitle";
import { MdOutlineClose } from "react-icons/md";
import SalesEstimatePDF from "../pages/SalesEstimatePDF";
import "../components/Table.css";
import moment from "moment/moment";
import {
  Calender,
  DropDownUI,
  TextInputForm,
  LoadingSpinner,
} from "../components/Forms";
import { toast } from "react-toastify";

const ProductHistory = [
  "S.NO",
  "Date",
  "Receipt No.",
  "Name",
  "Amount",
  "Received",
  "Balance",
  "Convert",
  "Status",
];

const SalesEstimation = () => {
  const location = useLocation();
  const { type, rowData } = location.state || {};

  const [show, setShow] = useState(false);
  const [invoiceModalShow, setInvoiceModalShow] = useState(false);
  const [selectedInvoiceType, setSelectedInvoiceType] = useState("");
  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setSelectedOption("");
  };
  const openFilter = () => setFilter(true);
  const closeFilter = () => setFilter(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [printrow, setPrintRow] = useState([]);
  const [selectedEstimations, setSelectedEstimations] = useState([]);
  const [filter, setFilter] = useState(false);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const [filterData, setFilterData] = useState({
    search_text: "",
    party_name: "",
    party_id: "",
    from_date: "",
    to_date: "",
  });

  const [dropdownKey, setDropdownKey] = useState(Date.now());

  const clearFilter = () => {
    setFilterData({
      search_text: "",
      party_id: "",
      from_date: "",
      to_date: "",
      bill_no: "",
    });
    setDropdownKey(Date.now());
  };

  const handleClearAll = () => {
    setFilterData({
      search_text: "",
      party_name: "",
      party_id: "",
      from_date: "",
      to_date: "",
      bill_no: "",
    });
    setDropdownKey(Date.now());
    setSelectedEstimations([]);
  };

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFilterData({
      ...filterData,
      [fieldName]: value,
    });
  };

  const setLabel = (value, field) => {
    const formattedDate = value ? moment(value).format("DD-MM-YYYY") : "";
    setFilterData({
      ...filterData,
      [field]: formattedDate,
    });
  };

  const [partySalesData, setPartySalesData] = useState([]);
  const fetchPartySalesData = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(`${API_DOMAIN}/sales_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: "",
          company_id: companyId,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to fetch party data");
      }

      const responseData = await response.json();
      if (responseData.code === 200) {
        setPartySalesData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      console.error("Error fetching party data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPartySalesData();
  }, []);

  const [userData, setUserData] = useState([]);

  const fetchData = async () => {
    try {
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/sales_estimation.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: filterData.search_text,
            party_name: filterData.party_name,
            party_id: filterData.party_id,
            from_date: filterData.from_date,
            to_date: filterData.to_date,
            bill_no: filterData.bill_no || "",
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const responseData = await response.json();
      if (responseData.status === 200) {
        setUserData(responseData.data);
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [filterData]);

  const filteredUserData = userData.filter((item) => {
    const billNo = item.bill_no?.toString() || "";
    const receiptNo = item.receipt_no?.toString() || "";
    const searchText = filterData.search_text?.toString() || "";

    const isSearchMatch =
      searchText === "" ||
      billNo.includes(searchText) ||
      receiptNo.includes(searchText);

    const partyName = item.party_name?.toLowerCase() || "";
    const filterPartyName = filterData.party_name?.toLowerCase() || "";

    const isPartyMatch = partyName.includes(filterPartyName);

    const itemDate = moment(item.bill_date, "DD-MM-YYYY");
    const fromDate = filterData.from_date
      ? moment(filterData.from_date, "DD-MM-YYYY")
      : null;
    const toDate = filterData.to_date
      ? moment(filterData.to_date, "DD-MM-YYYY")
      : null;

    const isDateMatch =
      (!fromDate && !toDate) ||
      (fromDate &&
        toDate &&
        itemDate.isBetween(fromDate, toDate, "day", "[]")) ||
      (fromDate && !toDate && itemDate.isSameOrAfter(fromDate, "day")) ||
      (!fromDate && toDate && itemDate.isSameOrBefore(toDate, "day"));

    return isSearchMatch && isPartyMatch && isDateMatch;
  });

  const handleCheckboxChange = (rowData) => {
    setSelectedEstimations((prev) => {
      if (
        prev.some(
          (item) => item.sales_estimation_id === rowData.sales_estimation_id
        )
      ) {
        return prev.filter(
          (item) => item.sales_estimation_id !== rowData.sales_estimation_id
        );
      } else {
        return [...prev, rowData];
      }
    });
  };

  const handleConvertToInvoice = () => {
    if (selectedEstimations.length === 0) {
      toast.error("Please select at least one estimation to convert!", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }
    setInvoiceModalShow(true); // Show the invoice type selection modal
  };

  const handleInvoiceTypeSubmit = async () => {
    if (!selectedInvoiceType) {
      toast.error("Please select an invoice type!", {
        position: "top-center",
        autoClose: 2000,
      });
      return;
    }

    try {
      setLoading(true);
      const companyId = localStorage.getItem("companyId");
      const response = await fetch(
        `${API_DOMAIN}/sales_estimation.php?id=${companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            bulk_convert: selectedEstimations,
            invoice_type: selectedInvoiceType, // Include invoice type in payload
          }),
        }
      );

      const responseData = await response.json();
      console.log("API Response:", responseData);
      if (responseData.status === 200) {
        toast.success("Sales Invoices Created Successfully!", {
          position: "top-center",
          autoClose: 2000,
        });
        setSelectedEstimations([]);
        setInvoiceModalShow(false);
        setSelectedInvoiceType("");
        fetchData();
      } else {
        toast.error(responseData.msg || "Error occurred during conversion", {
          position: "top-center",
          autoClose: 2000,
        });
      }
    } catch (error) {
      console.error("Error converting estimations:", error.message);
      toast.error("Error occurred during conversion", {
        position: "top-center",
        autoClose: 2000,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSalesEstimatePrintClick = async (rowData) => {
    try {
      const blob = await pdf(
        <SalesEstimatePDF data={rowData} type="Original" />
      ).toBlob();
      const url = URL.createObjectURL(blob);
      const printWindow = window.open(url, "_blank");
      printWindow.onload = () => {
        printWindow.print();
        URL.revokeObjectURL(url);
      };
    } catch (error) {
      console.error("Error generating PDF:", error.message);
    }
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const openPrintView = async (printrow, type) => {
    const documents = [];
    if (type === "Original" || type === "Duplicate" || type === "Triplicate") {
      const originalBlob = await pdf(
        <SalesEstimatePDF data={printrow} type="Original" />
      ).toBlob();
      documents.push({
        url: URL.createObjectURL(originalBlob),
        type: "Original",
      });
    }
    if (type === "Duplicate" || type === "Triplicate") {
      const duplicateBlob = await pdf(
        <SalesEstimatePDF data={printrow} type="Duplicate" />
      ).toBlob();
      documents.push({
        url: URL.createObjectURL(duplicateBlob),
        type: "Duplicate",
      });
    }
    if (type === "Triplicate") {
      const triplicateBlob = await pdf(
        <SalesEstimatePDF data={printrow} type="Triplicate" />
      ).toBlob();
      documents.push({
        url: URL.createObjectURL(triplicateBlob),
        type: "Triplicate",
      });
    }

    documents.forEach((doc) => {
      const printWindow = window.open(doc.url, "_blank");
      printWindow.onload = () => {
        printWindow.print();
        URL.revokeObjectURL(doc.url);
      };
    });
  };

  useEffect(() => {
    if (selectedOption !== "") {
      openPrintView(printrow, selectedOption);
    }
  }, [selectedOption, printrow]);

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        console.error("Error checking session:", error.message);
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }
  if (loading) {
    return (
      <LoadingSpinner message="Loading Sales Estimation..." height="300px" />
    );
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Container fluid className="pt-2">
        <div className="main px-2 my-3">
          <div className="mx-2">
            <Navbar>
              <Navbar.Brand>
                <PageTitle PageTitle={"Sales Estimation"} />
              </Navbar.Brand>
              <Nav className="ms-auto">
                <span className="mx-2 py-2">
                  <Buttons lable={<>Filter</>} onClick={openFilter} />
                </span>
                <span className="mx-2 py-2">
                  <Buttons lable={<>Clear</>} onClick={handleClearAll} />
                </span>
                <span className="mx-2 py-2">
                  <Buttons lable={<>{selectedEstimations.length}</>} disabled />
                </span>
              </Nav>
            </Navbar>
          </div>
          <Offcanvas show={filter} onHide={closeFilter} placement="end">
            <Offcanvas.Body>
              <Row>
                <Col lg="6">
                  <PageTitle PageTitle={<>Sales Estimation</>} />
                </Col>
                <Col lg="6" className="align-self-center">
                  <div className="text-end">
                    <Buttons
                      onClick={closeFilter}
                      lable={
                        <>
                          <MdOutlineClose />
                        </>
                      }
                    ></Buttons>
                  </div>
                </Col>
              </Row>
              <div>
                <div className="py-3">
                  <TextInputForm
                    labelname={"Search Receipt"}
                    placeholder={"Search Receipt"}
                    name="search_text"
                    value={filterData.search_text}
                    onChange={(e) => handleChange(e, "search_text")}
                  ></TextInputForm>
                </div>
                <div className="py-3">
                  <TextInputForm
                    placeholder={"Party Name"}
                    labelname={"Party Name"}
                    name="party_name"
                    value={filterData.party_name}
                    onChange={(e) => handleChange(e, "party_name")}
                  />
                </div>
                <Row>
                  <Col lg="6" className="align-self-center">
                    <div>
                      <Calender
                        key={dropdownKey}
                        setLabel={(date) => setLabel(date, "from_date")}
                        selectedDate={filterData.from_date}
                        calenderlabel="From Date"
                      />
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div>
                      <Calender
                        key={dropdownKey}
                        setLabel={(date) => setLabel(date, "to_date")}
                        selectedDate={filterData.to_date}
                        calenderlabel="To Date"
                      />
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="my-5 text-center">
                      <Buttons
                        lable={"Apply"}
                        onClick={() => closeFilter()}
                      ></Buttons>
                    </div>
                  </Col>
                  <Col lg="6" className="align-self-center">
                    <div className="my-5 text-center">
                      <Buttons lable={"Clear"} onClick={clearFilter}></Buttons>
                    </div>
                  </Col>
                </Row>
              </div>
            </Offcanvas.Body>
          </Offcanvas>
        </div>
        <div className="main p-3">
          <div className="py-1 mx-2">
            <Navbar>
              <Container fluid className="px-0">
                <Navbar.Brand>
                  <PageTitle PageTitle={"Transactions"} />
                </Navbar.Brand>
                <Nav className="ms-auto">
                  <span className="mx-2 py-2">
                    <Buttons
                      lable={<>Add New</>}
                      onClick={() =>
                        navigate("/console/sales/estimation/create")
                      }
                    />
                  </span>
                  {selectedEstimations.length > 0 && (
                    <span className="mx-2 py-2">
                      <Buttons
                        lable={<>Submit</>}
                        onClick={handleConvertToInvoice}
                      />
                    </span>
                  )}
                </Nav>
              </Container>
            </Navbar>
          </div>
          <div className="py-2 c-table table-scroll mx-2">
            <TableUI
              headers={ProductHistory}
              body={filteredUserData}
              type="salesEstimation"
              handleEditClick={handleSalesEstimatePrintClick}
              pageview={"yes"}
              onDelete={fetchData}
              handleCheckboxChange={handleCheckboxChange}
              selectedEstimations={selectedEstimations}
            ></TableUI>
          </div>
        </div>
      </Container>
      <Modal
        size="sm"
        show={invoiceModalShow}
        onHide={() => {
          setInvoiceModalShow(false);
          setSelectedInvoiceType("");
        }}
        centered
      >
        <Modal.Header>
          <PageHead
            pagehead={<>Select Invoice Type</>}
            onClick={() => {
              setInvoiceModalShow(false);
              setSelectedInvoiceType("");
            }}
          />
        </Modal.Header>
        <ModalBody>
          <Container>
            <Row>
              <Col md={6}>
                <Form.Check
                  type="radio"
                  id="invoice"
                  name="invoice_type"
                  value="invoice"
                  label="Invoice"
                  checked={selectedInvoiceType === "invoice"}
                  onChange={(e) => setSelectedInvoiceType(e.target.value)}
                />
              </Col>
              <Col md={6}>
                <Form.Check
                  type="radio"
                  id="tax_invoice"
                  name="invoice_type"
                  value="tax_invoice"
                  label="Tax Invoice"
                  checked={selectedInvoiceType === "tax_invoice"}
                  onChange={(e) => setSelectedInvoiceType(e.target.value)}
                />
              </Col>
            </Row>
            <Row className="mt-4">
              <Col md={6} className="text-center">
                <Buttons
                  lable={<>Submit</>}
                  onClick={handleInvoiceTypeSubmit}
                />
              </Col>
              <Col md={6} className="text-center">
                <Buttons
                  lable={<>Cancel</>}
                  onClick={() => {
                    setInvoiceModalShow(false);
                    setSelectedInvoiceType("");
                  }}
                />
              </Col>
            </Row>
          </Container>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default SalesEstimation;
